<div class="container" flexLayout="column" flexLayoutAlign="start start">
  <h1>We Apologize</h1>
  <p>
    To be able to use this system you must first be invited. Please try again once you are invited or
    <a href="#">contact support</a> if the problem persists.
  </p>
</div>
